import { render, staticRenderFns } from "./viewDis.vue?vue&type=template&id=261f1c1a"
import script from "./viewDis.vue?vue&type=script&lang=js"
export * from "./viewDis.vue?vue&type=script&lang=js"
import style0 from "./viewDis.vue?vue&type=style&index=0&id=261f1c1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports